import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SplashFooter from "../common/footer/SplashFooter";
import SplashHeader from "../common/header/SplashHeader";
import SEO from "../common/SEO";
import SplashBanner from "../component/banner/SplashBanner";
import SplashCta from "../component/cta/SplashCta";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SplashData from "../data/splash/SplashData.json";
import { slugify } from "../utils";
import { FaAngleRight } from "react-icons/fa";
import DarkCardsLists from "../component/DarkCardsList";
import { useTranslation } from "react-i18next";
import BlogGridOne from "../component/blog/BlogGridOne";
import BlogSidebar from "../component/blog/BlogSidebar";
import CardsLists from "../component/CardsLists";
import HeaderFour from "../common/header/HeaderFour";
import HeaderOne from "../common/header/HeaderOne";
import { useSelector } from "react-redux";
import { logPageView } from "../services/analytics";

const DemoData = SplashData[0];
const FeatureData = SplashData[1];

const viewStates = {
  showCertificateInput: "showCertificateInput",
};
const Splash = () => {
  const { t } = useTranslation();
  const { currentCustomer } = useSelector((state) => state.store);
  const [viewState, setViewState] = useState({
    state: null,
  });

  // Registrar pageview en Google Analytics
  useEffect(() => {
    logPageView(window.location.pathname, 'Gestión Ciudad - Inicio');
  }, []);

  return (
    <>
      <SEO title="Gestión Ciudad" />
      <ColorSwitcher />
      <main className="main-wrapper">
        {/* <SplashHeader /> */}
        <HeaderOne />
        <SplashBanner />
        <div
          className="section section-padding bg-color-light "
          style={{
            paddingTop: "60px",
            paddingBottom: "30px",
            textAlign: "center",
            zIndex: 2
          }}
        >
          <a
            // to={`/${currentCustomer?.shortname}/`}
            className="gc-btn  btn-fill-primary"
            onClick={() => {
              window.open(
                `https://${window.location.host}${window["APP_HOME"]}`,
                "_blank"
              );
            }}
          >
            {currentCustomer?.apps_config?.systemName || "Gobierno Electrónico"}
          </a>
        </div>
        <div
          style={{
            zIndex: 3,
            position: "relative",
          }}
        >
          {viewState.showCertificateInput && (
            <div
              className="dialog-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="dialog-content"
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="dialog-header" style={{ textAlign: "center" }}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/icon-36.png"}
                    alt="Logo"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      marginBottom: "20px",
                    }}
                  />
                  <h4>Descargar Certificado</h4>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // open new window to /certificate/validation/${document.getElementById("certificateNumber").value}
                    window.open(
                      `/certificate/validation/${
                        document.getElementById("certificateNumber").value
                      }?register_id=${
                        document.getElementById("register_number").value
                      }`,
                      "_blank"
                    );
                  }}
                >
                  <div className="form-group">
                    <label htmlFor="certificateNumber">
                      Número de certificado
                    </label>
                    <input
                      type="text"
                      id="certificateNumber"
                      placeholder="Ingrese número de certificado"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="register_number">Número de registro</label>
                    <input
                      type="text"
                      id="register_number"
                      placeholder="Ingrese número de registro"
                    />
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-lg"
                      onClick={() =>
                        setViewState({ showCertificateInput: false })
                      }
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-lg btn-success"
                      style={{}}
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          <CardsLists
            grid
            title={
              window["configSite"]
                ? window["configSite"]["siteName"]
                : t("Transformamos la ciudad")
            }
            subtitle={
              window["configSite"]
                ? window["configSite"]["siteDescription"]
                : t("Usamos la tecnología para mejorar la calidad de vida")
            }
            data={[
              {
                id: 1,
                title: "Trámites en<br /> línea",
                icon: "/images/icon/icon-37.png",
                para: "Realiza tus trámites de forma rápida y sencilla desde cualquier lugar.",
                onClick: () => {
                  // Handle click event
                },
                href: "/procedures",
              },
              {
                id: 2,
                title: "Certificados <br /> Digitales",
                icon: "/images/icon/icon-38.png",
                para: "Obtén tus certificados de forma rápida y sencilla desde cualquier lugar.",
                onClick: () => {
                  // Handle click event
                  setViewState((prev) => ({
                    ...prev,
                    showCertificateInput: true,
                  }));
                },
              },
              {
                id: 3,
                title: "Pagos <br /> en Línea",
                icon: "/images/icon/icon-32.png",
                para: "Realiza tus pagos de forma rápida y sencilla desde cualquier lugar.",
                onClick: () => {
                  // Handle click event
                },
              },
              {
                id: 4,
                title: "Documentación <br> en Línea",
                icon: "/images/icon/icon-24.png",
                para: "Accede a toda la documentación necesaria para guiarte paso a paso.",
                onClick: () => {
                  // Handle click event
                },
              },
              {
                id: 5,
                disabled: true,
                title: "Obtén <br /> soporte",
                icon: "/images/icon/icon-22.png",
                para: "Accede a nuestro equipo de soporte para resolver tus dudas.",
                onClick: () => {
                  // Handle click event
                },
              },
            ]}
          />
        </div>
        <div className="section-padding-equal">
          <div className="container">
            <div className="row row-40">
              <div className="col-lg-8">
                <BlogGridOne />
              </div>
              <div className="col-lg-4">
                <BlogSidebar />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="section main-demo-area bg-color-light" id="splash-demo">
          <div className="container">
            <div className="section-heading heading-left">
              <div className="row align-items-center">
                <div className="col-xl-6 col-lg-7">
                  <h2 className="title">Our templates are just ready to use</h2>
                </div>
                <div className="col-xl-4 col-lg-5 offset-xl-2">
                  <p>
                    You will love all of the features in our Template. 100%
                    guaranteed satisfaction.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              {DemoData.map((data) => (
                <div className="col-md-6" key={data.id}>
                  <div className="single-demo">
                    <Link
                      to={`${process.env.PUBLIC_URL}/${slugify(data.title)}`}
                    >
                      <span className="thumb">
                        <img
                          src={`${process.env.PUBLIC_URL}${data.height_img}`}
                          alt={data.title}
                        />
                      </span>
                      <h4 className="title">{data.title}</h4>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <ul className="shape-group list-unstyled">
            <li className="shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-35.png"}
                alt="Shape"
              />
            </li>
            <li className="shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Shape"
              />
            </li>
          </ul>
        </div> */}

        <DarkCardsLists
          title={t("Transformamos la ciudad")}
          subtitle={t("Usamos la tecnología para mejorar la calidad de vida")}
          data={FeatureData}
        />

        {/* <div
          className="section section-padding bg-color-light spalsh-why-choose"
          id="splash-why-choose"
        >
          <div className="container">
            <div className="section-heading heading-left">
              <div className="row align-items-center">
                <div className="col-xl-6 col-lg-7">
                  <h2 className="title">Why buy the template from us?</h2>
                </div>
                <div className="col-xl-4 col-lg-5 offset-xl-2">
                  <p>
                    Every template is built with such efforts that they are
                    ready to meet all of our clients’ expectations.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              {FeatureData.slice(9, 12).map((data) => (
                <div className="col-xl-4 col-lg-6" key={data.id}>
                  <div className="why-buy-box">
                    <div className="heading">
                      <div className="icon">
                        <img
                          src={process.env.PUBLIC_URL + data.icon}
                          alt="Thumb"
                        />
                      </div>
                      <h5
                        className="title"
                        dangerouslySetInnerHTML={{ __html: data.title }}
                      ></h5>
                    </div>
                    <p>{data.para}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="row justify-content-center">
              <div className="col-xl-4 col-lg-6">
                <div className="support-box online-documentation splash-hover-control">
                  <a href="https://new.gestionciudad.com/docs/abstrak-react/">
                    <div className="inner">
                      <div className="content">
                        <div className="heading">
                          <h4 className="title">
                            Online
                            <br /> Documentation
                          </h4>
                          <div className="icon">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icon/icon-25.png"
                              }
                              alt="Thumb"
                            />
                          </div>
                        </div>
                        <p>Well organized and up to date</p>
                      </div>
                      <div className="btn-area">
                        <span className="item-btn">
                          <FaAngleRight />
                        </span>
                      </div>
                    </div>
                    <ul className="shape-group list-unstyled">
                      <li className="shape-1">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/others/bubble-34.png"
                          }
                          alt="Shape"
                        />
                      </li>
                      <li className="shape-2">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/others/line-8.png"
                          }
                          alt="Shape"
                        />
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="support-box support-ticket splash-hover-control">
                  <a href="https://support.gestionciudad.com/support/">
                    <div className="inner">
                      <div className="content">
                        <div className="heading">
                          <h4 className="title">
                            Submit A <br /> Support Ticket
                          </h4>
                          <div className="icon">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icon/icon-26.png"
                              }
                              alt="Thumb"
                            />
                          </div>
                        </div>
                        <p>
                          We response within 1 Business day. weekends excluded.
                        </p>
                      </div>
                      <div className="btn-area">
                        <span className="item-btn">
                          <FaAngleRight />
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="line-shape">
            <img
              src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
              alt="Line"
            />
          </div>
        </div> */}
        <SplashCta />
        <SplashFooter />
      </main>
    </>
  );
};

export default Splash;
